import { z } from "zod";

export const PackageCodeSchema = z.enum([
  "classic",
  "signature",
  "story",
  "zero_proof",
]);
export type PackageCode = z.infer<typeof PackageCodeSchema>;

export const PACKAGE_CODE_LABELS: Record<PackageCode, string> = {
  classic: "Classic",
  signature: "Signature",
  story: "Story",
  zero_proof: "Zero-Proof",
};

// The playbook's default recommendation — pre-selected/highlighted in the
// quote builder's package picker (§2/Phase 2 of the plan).
export const DEFAULT_PACKAGE_CODE: PackageCode = "signature";

export const PackageSchema = z.object({
  id: z.string(),
  code: PackageCodeSchema,
  name: z.string(),
  base_price_cents: z.number(),
  description: z.string().nullable(),
  includes: z.array(z.string()),
});
export type Package = z.infer<typeof PackageSchema>;

export const PackageListResponseSchema = z.object({
  items: z.array(PackageSchema),
});
export type PackageListResponse = z.infer<typeof PackageListResponseSchema>;
